import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from './../../shared';
import { BlogPage } from  './../blog-page';

@Component({
  selector: 'linescape-ci-award-finalist',
  template: require('./linescape-ci-award-finalist.component.html'),
  styles: [require('./../blog.component.scss'), require('./linescape-ci-award-finalist.component.scss')]
})
export class LinescapeCIAwardFinalistComponent extends BlogPage {
  title = "Linescape Selected as Finalist for CI Award - Linescape";
  description = "Containerisation International are pleased to announce the finalists for the CI Awards 2012.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/linescape-ci-award-finalist/linescape-ci-award-finalist.component.ts